/**
 * Email format regex requiring a TLD of at least 2 alphabetical characters.
 * Rejects addresses like `ss@im.o` that pass browser-native validation
 * but are rejected by backend controllers (leads, email submissions).
 *
 * Local part: no leading/trailing/consecutive dots.
 * Domain: each label must start and end with alphanumeric.
 * TLD: at least 2 alphabetical characters.
 */
export const EMAIL_REGEX =
  /^[a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

/** Returns true when value is a well-formed email address. */
export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value.trim());
}
